import Emojify from "app/components/shared/Emojify";
import Icon from "app/components/shared/Icon";
import UserAvatar from "app/components/shared/UserAvatar";

interface Props {
  authorName?: string;
  authorAvatar?: string;
  creatorVerified: boolean;
  pipelineSchedule?: {
    url: string;
    label: string;
  };
}

/**
 * The actor responsible for triggering a build.
 */
export function Author({ pipelineSchedule, authorName, authorAvatar, creatorVerified }: Props) {
  if (pipelineSchedule) {
    return <Schedule url={pipelineSchedule.url} label={pipelineSchedule.label} />;
  }

  return (
    <User
      name={authorName || "Unknown"}
      avatar={authorAvatar || ""}
      creatorVerified={creatorVerified}
    />
  );
}

const Schedule = ({ url, label }: { url: string; label: string }) => (
  <span>
    Schedule{" "}
    <a href={url} className="semi-bold color-inherit hover-color-inherit">
      <Icon
        icon="schedules"
        style={{
          width: 15,
          height: 15,
        }}
      />{" "}
      <Emojify text={label} />
    </a>
  </span>
);

const User = ({
  name,
  avatar,
  creatorVerified,
}: {
  name: string;
  avatar: string;
  creatorVerified: boolean;
}) => (
  <span className="inline-flex gap-1 items-center shrink-0">
    <UserAvatar
      size="SMALL"
      user={{
        name: name,
        avatar: { url: avatar },
      }}
    />
    <span className="font-medium">{name}</span>
    {creatorVerified && (
      <span className="inline-flex rounded-sm text-white bg-green-400 text-xs px-1">Verified</span>
    )}
  </span>
);
